import { DisparityQuadtree, hasOwnProperty, PerspectiveImageQuadtree } from "../../infra3d";
import { IMAGEDISPLAYMODE } from "../internal";
import { GeoFrameCollection } from "./geoframecollection";
import { AuthMode } from "../viewer/AuthMode";
// TODO: Naming currently along the lines of stream.
export class PerspectiveGeoFrameCollection extends GeoFrameCollection {
    constructor(scene, currentgeoframe, geoframearray) {
        super(scene, currentgeoframe, geoframearray);
    }
    // TODO: Naming.
    load(frame = null, cachingstepsize = 1) {
        if (this.onbuffering)
            this.onbuffering(true);
        let framenumber = frame ? this.frameIndex(frame) : 0;
        // Calculate Centroid for this stream:
        if (this.currentgeoframe != null)
            framenumber = this.currentgeoframe.getFramenumber();
        const numEntries = this.geoframearray.length;
        const mlt = 1.0 / numEntries;
        let easting_center = 0;
        let northing_center = 0;
        let height_center = 0;
        for (let i = 0; i < numEntries; i++) {
            easting_center = easting_center + mlt * this.geoframearray[i]["easting"];
            northing_center = northing_center + mlt * this.geoframearray[i]["northing"];
            height_center = height_center + mlt * this.geoframearray[i]["height"];
        }
        this.centroid = [easting_center, northing_center, height_center];
        //Create the QuadtreeNode
        const urls = [];
        for (const geoframe of this.geoframearray) {
            urls.push(geoframe.dataPath);
        }
        this.infrascene.engine.setCentroid([easting_center, northing_center, height_center]);
        //Load Image-Quadtree
        const frameZeroCoord = [
            this.geoframearray[0]["easting"],
            this.geoframearray[0]["northing"],
            this.geoframearray[0]["height"],
        ];
        const frameZeroOri = [
            this.geoframearray[0]["omega"],
            this.geoframearray[0]["phi"],
            this.geoframearray[0]["kappa"],
        ];
        const im = this.measureinfo.imagemeta;
        this.imagequadtree = new PerspectiveImageQuadtree(urls, im.tilesize, im.width, im.height, im.minzoom, im.maxzoom, undefined, frameZeroCoord, frameZeroOri, im.pixsize * 0.000001, im.focallength * 0.001);
        this.scene.infrascene.panoramaMode = false;
        this.cachnotreadycbf = () => {
            this.cacheready = false;
            if (this.onbuffering)
                this.onbuffering(true);
        };
        this.imagequadtree.cacheNotReadyEvent = () => {
            this.cachnotreadycbf();
        };
        this.cachereadycbf = () => {
            this.cacheready = true;
            if (this.onbuffering)
                this.onbuffering(false);
        };
        this.imagequadtree.cacheReadyEvent = () => {
            this.cachereadycbf();
        };
        this.imagequadtree.visibleTilesNotReady = () => {
            this.alltilesready = false;
            if (this.onTileLoading)
                this.onTileLoading(true);
        };
        this.imagequadtree.visibleTilesReady = () => {
            this.alltilesready = true;
            if (this.onTileLoading)
                this.onTileLoading(false);
        };
        this.stoppedcbf = () => {
            if (this.disparityquadtree != null) {
                this.disparityquadtree.setDataIndex(this.getCurrentFramenumber());
            }
        };
        this.imagequadtree.stoppedEvent = () => {
            this.stoppedcbf();
        };
        this.infrascene.add(this.imagequadtree);
        this.imagequadtree.setActive(true);
        this.imagequadtree.frameskippedcbf = (newframenmbr) => {
            if (newframenmbr > this.geoframearray.length - 1)
                newframenmbr = this.geoframearray.length;
            if (newframenmbr < 0)
                newframenmbr = 0;
            this.currentgeoframe = this.geoframearray[newframenmbr];
            //make sure keep disparityquadtree in sync if a first frame was skipped
            if (this.disparityquadtree != null && !this.isRunning) {
                this.disparityquadtree.setDataIndex(this.getCurrentFramenumber());
            }
        };
        //Load Disparity-Quadtree
        const dm = this.measureinfo.depthmapmeta;
        if (hasOwnProperty(dm, "structure")) {
            if (dm.structure !== "none" && this.scene.authmode == AuthMode.edit) {
                this.disparityquadtree = new DisparityQuadtree(urls, dm.tilesize, dm.width, dm.height, dm.minzoom, dm.maxzoom);
                this.disparityquadtree.currentImageIndex = framenumber;
                this.infrascene.add(this.disparityquadtree);
            }
        }
        //Set Camera Parameters
        this.infrascene.sceneCamera.setPosition([
            this.geoframearray[framenumber]["easting"],
            this.geoframearray[framenumber]["northing"],
            this.geoframearray[framenumber]["height"],
        ]);
        this.infrascene.sceneCamera.setOrientation([
            this.geoframearray[framenumber]["omega"],
            this.geoframearray[framenumber]["phi"],
            this.geoframearray[framenumber]["kappa"],
        ]);
        this.infrascene.sceneCamera.setCameraIntrinsics({
            IMAGE_WIDTH: this.measureinfo.imagemeta.width,
            IMAGE_HEIGHT: this.measureinfo.imagemeta.height,
            PIXEL_SIZE: this.measureinfo.imagemeta.pixsize * 0.000001,
            NEAR: this.measureinfo.imagemeta.focallength * 0.001,
            MIN_ZOOM: this.measureinfo.imagemeta.minzoom,
            MAX_ZOOM: this.measureinfo.imagemeta.maxzoom,
        });
        this.imagequadtree.framechangedcbf = (f) => {
            this._imageChanged();
        };
        this.hasloaded = true;
        //todo: set reversemode for caching
        // if (this.reverseMode) this.imagequadtree.reverseMode = true;
        this.displaymode = IMAGEDISPLAYMODE.FRAMESTEPPING;
        this.searchToFramenumber(framenumber, cachingstepsize);
        this.fitToCanvas();
    }
    unload() {
        this.infrascene.remove(this.imagequadtree);
        this.imagequadtree.setActive(false);
        this.imagequadtree.destroy();
        this.imagequadtree = null;
        try {
            this.infrascene.remove(this.disparityquadtree);
            this.disparityquadtree.destroy();
            this.disparityquadtree = null;
        }
        catch (e) {
            console.log("ERROR stream unload");
        }
        if (this.lookatfc != null) {
            this.lookatfc.destroy();
            this.lookatfc = null;
        }
        this.hasloaded = false;
    }
}
//# sourceMappingURL=perspectivegeoframecollection.js.map